export default "__VITE_ASSET__draZAGSK__"